import { render, staticRenderFns } from "./TabsDashboardBooking.vue?vue&type=template&id=2c4357b7&"
import script from "./TabsDashboardBooking.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports